import { useRef } from "react";

export default function useReCaptcha() {
    return useRef<{
        executeAsync: () => Promise<string>;
    }>(null);
};